import type { SetOptional } from 'type-fest';

import { type BaseItem, type NullablePartial } from '../common.js';

export enum CloseNoteAction {
  SaveAndClose = 'SAVE_AND_CLOSE',
  Submit = 'SUBMIT',
  Sign = 'SIGN',
}

export interface BaseDocumentTemplateConfiguration {
  ehrInstanceId: string;
  documentTemplateId: string;
  title: string | null;
  type: string | null;
  action: CloseNoteAction | null;
  shouldOverrideOldMappings: boolean;
  markComplete: boolean;
  deleted: Date | null;
}

export type FindAllOptions = Partial<BaseDocumentTemplateConfiguration>;

export type CreateValues = SetOptional<
  NullablePartial<BaseDocumentTemplateConfiguration>,
  'shouldOverrideOldMappings' | 'markComplete'
>;

export type UpdateValues = Partial<CreateValues>;

export interface DocumentTemplateConfiguration
  extends BaseDocumentTemplateConfiguration, BaseItem {}

export interface DocumentTemplateConfigurationHistory extends Omit<
  DocumentTemplateConfiguration,
  'deleted'
> {
  userId: string;
  documentTemplateConfigurationCreated: Date;
  documentTemplateConfigurationId: string;
  documentTemplateConfigurationDeleted: Date | null;
}
